import { Span, MultilineInput } from "@tblabs/truffle";
import { Table } from "@tblabs/truffle/Controls/TableBuilder/Table";
import { Human } from "../../../Models/Human";
import { PaymentForm, PaymentFormNames } from "../../../Models/Payment/PaymentForm";
import { TimeUtils } from "../../../Utils/TimeUtils";
import { PaymentStepData } from "../Models/PaymentStepData";
import { TextFormatter } from "../../../Utils/TextFormatter";


export class PaymentReturnInfoForAdmin extends Table
{
    constructor(payment: PaymentStepData, customer?: Human)
    {
        super();
        this.Class("payment-info-table");

        if (payment.Form.Is(PaymentForm.Unset))
        {
            this.AddRow("Forma", "⚠️ Nie została określona");
            return;
        }

        let customerAccountNumber = payment.AccountNumber.value || customer?.BankAccountNumber?.value;

        if (payment.Form.Is(PaymentForm.BankTransfer))
        {
            customerAccountNumber = "To z którego przyszedł przelew";
        }

        this.AddRow("Forma", PaymentFormNames[payment.Form.value])
            .AddRow("Tytułem", payment.Title.value)
            .AddRow("Kwota", payment.AmountAsString)

        switch (payment.Form.value)
        {
            default:
            case PaymentForm.BankTransfer:
                this.AddRow("Konto", new MultilineInput(customerAccountNumber || "⚠️ brak numeru konta").Readonly().Rows(3).Background("none").BorderNone().Padding(0).Margin(0).Color("#000"))
                    .AddRow("Odbiorca", (customer?.Name?.value || "---") + "\n" + (customer?.Address?.value || "---"))
                break;

            case PaymentForm.Blik:
                this.AddRow("Numer", customerAccountNumber || TextFormatter.NicePhoneNumber(customer?.Phone?.value || "") || "⚠️ brak numeru telefonu")
                    .AddRow("Odbiorca", customer?.Name?.value || "---")
                break;

            case PaymentForm.Cash:
                break;

            case PaymentForm.Crypto:
                const btcAmount = (payment.Amount.value / payment.ExchangeRate.value).toFixed(8);
                this.AddRow("Do przelania", new Span(btcAmount + " " + payment.PaymentCurrency.value).Bold())
                    .AddRow("Kurs BTC", payment.ExchangeRate.value + " PLN za 1 BTC")
                    .AddRow("Adres portfela", new MultilineInput(customerAccountNumber || "⚠️ brak adresu portfela").Readonly().Rows(3).Background("none").BorderNone().Padding(0).Margin(0).Color("#000"))
                break;
        }

        this.AddRow("Termin", "do " + TimeUtils.FormattedDate(payment.Deadline.value));
    }
}
